import { Button, message } from "antd";
import axios from "../../../../context/axiosConfig";
import { useAuth } from "../../../../context/AuthContext";
import formatPrice from "../../../../components/formatPrice";

const getSafePercent = (numerator, denominator) => {
	const num = Number(numerator);
	const den = Number(denominator);

	if (!Number.isFinite(num) || !Number.isFinite(den) || den === 0) {
		return "0.00";
	}

	return ((num / den) * 100).toFixed(2);
};

const LinkToSumUp = ({ wplywid, personid, transferid, selectedperson }) => {
	const { user } = useAuth();

	const copyToClipboard = async () => {
		const deductions = selectedperson.msr_reckonings.reduce(
			(sum, reck) =>
				sum +
				parseFloat(reck.msr_reckonings_deduction_from_income) +
				reck.msr_deductions.reduce(
					(sum2, dd) => sum2 + dd.msr_deductions_amount,
					0,
				),
			0,
		);
		const deductionPercent = getSafePercent(
			deductions,
			selectedperson.msr_persons_amount,
		);
		const finalAmount = selectedperson.msr_persons_amount - deductions;

		const params = new URLSearchParams();
		params.set("personid", personid);
		if (
			transferid !== null &&
			transferid !== undefined &&
			String(transferid).trim() !== ""
		) {
			params.set("transferid", transferid);
		}
		const url = `${
			window.location.origin
		}/#/wplywy/${wplywid}?${params.toString()}`;

		const textToCopy = `${selectedperson.msr_persons_name} ${
			selectedperson.msr_persons_lastname
		} | Kwota ${formatPrice(
			selectedperson.msr_persons_amount,
		)} zł -- [${deductionPercent}%] -> ${formatPrice(
			finalAmount,
		)} zł\n${url}`;
		navigator.clipboard.writeText(textToCopy);
		message.success("Dane zostały skopiowane");
	};

	return <Button onClick={() => copyToClipboard()}>Kopiuj do schowka</Button>;
};

export default LinkToSumUp;
